<template>
<div class="product-card-wrapper">
<transition-group name="fadeDown" mode="out-in" tag="div" :class="'ui stackable doubling '+getCardsLayoutSize+' cards'" >

  <a :class="['product-card', 'ui card']"
      v-for="product in paginatedProducts"
      v-bind:key="product.productId"
      @click="showProductDetails(product.productId)"
      :title="product.productTitle || 'Product'">

    <div class="card-stripe" :class="getBuyBoxStatus(product) ? getCardStripeClass(getBuyBoxStatus(product)) : 'unknown'"></div>
    <div class="card-image-area">
      <img v-if="product.largeImageUrl" :src="product.largeImageUrl" class="card-product-image" alt="">
      <svg v-else class="placeholder" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="2" y="7" width="20" height="14" rx="2"></rect><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"></path></svg>
      <div v-if="getAlertCount(product) > 0" class="card-alert-badge">{{ getAlertCount(product) }} alert{{ getAlertCount(product) !== 1 ? 's' : '' }}</div>
      <div v-if="getBuyBoxStatus(product)" class="card-bb"><span class="bb-badge" :class="getCardStripeClass(getBuyBoxStatus(product))">{{ getBuyBoxLabel(getBuyBoxStatus(product)) }}</span></div>
      <!-- <div class="card-check" @click.stop></div> -->
    </div>
    <div class="card-body">
      <div class="card-market"><span class="market-tag">{{ getMarketplaceEmoji(product.marketplace.toUpperCase()) }} {{ product.marketplace }}</span></div>
      <div class="card-name" :title="product.productTitle">{{ truncateToTwoLines(product.productTitle) }}</div>
      <div class="card-asin">{{ getAsin(product) }}</div>
      <div class="card-rating" :title="product.reviewHealthStatus === 'red' ? (product.reviewHealthNote || '') : null">{{ ratingSummary(product.rating, product.reviewCount) }}<span v-if="product.reviewHealthStatus === 'red'" class="card-rating-dot"></span></div>
      <div class="card-cogs-strip" :class="{ missing: !hasProductCogs(product) }" @click.stop>
        <template v-if="hasProductCogs(product)">
          <div class="cogs-col cogs-col-clickable" @click.prevent="openCogsModal(product)" title="Edit product cost and margin">
            <div class="cogs-strip-label">COGS</div>
            <div class="cogs-strip-value">${{ formatPrice(getProductCogs(product)) }}</div>
          </div>
          <div class="cogs-strip-divider"></div>
          <div class="cogs-col cogs-col-add cogs-col-with-edit">
            <div class="cogs-strip-label">Margin</div>
            <div class="cogs-strip-value" :class="getMarginCogsClass(calculateMargin(product))">{{ calculateMargin(product) }}%</div>
            <span class="add-cogs edit-cogs-link" @click.stop.prevent="openCogsModal(product)">Edit COGS</span>
          </div>
        </template>
        <template v-else>
          <div class="cogs-col"><div class="cogs-strip-label">COGS</div><div class="cogs-strip-value empty">Not set</div></div>
          <div class="cogs-strip-divider"></div>
          <div class="cogs-col cogs-col-add"><span class="add-cogs" @click.stop.prevent="openCogsModal(product)">+ Add COGS</span></div>
        </template>
      </div>
    </div>
    <div class="card-footer">
      <span class="card-footer-sales"><strong>{{ product.salesYesterday }}</strong> units ystd.</span>
      <div class="action-btn" @click.stop.prevent="$parent.$parent.$refs.chartModal && $parent.$parent.$refs.chartModal.open(product, null)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg></div>
    </div>
  </a>

</transition-group>

<!-- Product Cost & Margin Modal -->
<ProductCostMarginModal 
  ref="productCostMarginModal"
  @cost-margin-updated="handleCostMarginUpdated">
</ProductCostMarginModal>
</div>
</template>

<script>
import $ from 'jquery'
import ProductCostMarginModal from './ProductCostMarginModal.vue'
import productPricingMixin from '../mixins/productPricingMixin.js'
import { ratingSummary } from '../utils/reviewHealth.js'

export default {
  mixins: [productPricingMixin],
  components: {
    ProductCostMarginModal
  },
  data: function () {
    return {
      reds: {},
      ambers: {},
      stockReds: {},
      stockAmbers: {},
      productGroupId2products: {},
      productGroupIds: [],
      groupedProducts: [],
      currentPage: 0,
      itemsPerPage: 20,
    }
  },
  watch: {
    currentPage: function () {
      this.$emit('page-changed', this.currentPage)
    }
  },
  props: {
    worldStore: {
      type: Object,
      required: true
    },
    filterByMarket: {
      type: Array,
      default: () => []
    },
    filterBySellAcc: {
      type: Array,
      default: () => []
    },
    filterMissingCogs: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /** "★ 4.2 (1,191)"; "—" when the rating is unknown (null), never "0.0". */
    ratingSummary: function (rating, count) {
      return ratingSummary(rating, count)
    },
    toMonth: (m) => ({1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'}[m]),
    salesCountTotal: function (productIds, t) {
      const getSales = id => {
        const product = this.$parent.$parent.$parent.worldStore.products[id]
        if (product && product.salesToday !== undefined && product.salesYesterday !== undefined) {
          return {
            today: product.salesToday,
            yesterday: product.salesYesterday
          }
        }
        return null
      }
      if (t === 'y') return productIds.reduce((prevVal, id) => prevVal + (getSales(id) !== null ? getSales(id).yesterday : 0), 0)
      if (t === 't') return productIds.reduce((prevVal, id) => prevVal + (getSales(id) !== null ? getSales(id).today : 0), 0)
    },
    showProductDetails: function (productId) {
      this.$emit('open-product-details', productId)
    },
    calc: function (worldStore) {
      console.log('ProductCard calc() called')
      // Add null checks to prevent errors
      if (!worldStore || !worldStore.products) {
        console.warn('ProductCard: worldStore or products is null/undefined')
        this.groupedProducts = []
        this.productGroupIds = []
        return
      }
      
      console.log('ProductCard calc: processing', Object.keys(worldStore.products).length, 'products')
      const productGroupId2productIds = this.getProductGroupId2productIds(worldStore.products)
      const productId2ProductGroupId = this.getProductId2ProductGroupId(worldStore.products)
      const productGroupIds = Object.keys(productGroupId2productIds)

      // Use pre-calculated alert counts from API if available, otherwise calculate them
      if (worldStore.reds && worldStore.ambers) {
        this.reds = worldStore.reds
        this.ambers = worldStore.ambers
      } else {
        const amberErrorCount = this.getErrorCount(productGroupIds, 1, worldStore.watchDogs, worldStore.products, productId2ProductGroupId)
        const redErrorCount = this.getErrorCount(productGroupIds, 2, worldStore.watchDogs, worldStore.products, productId2ProductGroupId)
        this.reds = redErrorCount.byProductGroupId
        this.ambers = amberErrorCount.byProductGroupId
      }

      const stockAmberErrorCount = this.getWDErrorCount(productGroupIds, 1, worldStore.watchDogs.inventory, worldStore.products, productId2ProductGroupId)
      const stockRedErrorCount = this.getWDErrorCount(productGroupIds, 2, worldStore.watchDogs.inventory, worldStore.products, productId2ProductGroupId)
      this.stockReds = stockRedErrorCount.byProductGroupId
      this.stockAmbers = stockAmberErrorCount.byProductGroupId

      const productGroupId2products = {}
      for (let i = 0; i < productGroupIds.length; ++i) {
        const productGroupId = productGroupIds[i]
        const productIdsForProductGroupId = productGroupId2productIds[productGroupId]
        productGroupId2products[productGroupId] = (this.productGroupId2products.hasOwnProperty(productGroupId)
          ? this.addKeepingOrder(this.productGroupId2products[productGroupId].map(p => p.productId), productGroupId2productIds[productGroupId])
          : productIdsForProductGroupId.sort((a, b) => {
            const redA = this.reds[a] || 0
            const redB = this.reds[b] || 0
            const amberA = this.ambers[a] || 0
            const amberB = this.ambers[b] || 0
            let compResult = redB - redA
            if (compResult !== 0) return compResult
            return amberB - amberA
          })).map(pid => worldStore.products[pid])
      }
      this.productGroupId2products = productGroupId2products
      this.productGroupIds = productGroupIds.sort((a0, b0) => {
        const a = productGroupId2products[a0][0]
        const b = productGroupId2products[b0][0]
        let compResult = b.marketplace.localeCompare(a.marketplace)
        if (compResult !== 0) return compResult
        return a.productTitle.localeCompare(b.productTitle)
      })
      let sortedUnfoldedProductsIDs = []
      for (let i = 0; i < this.productGroupIds.length; ++i) {
        sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs.concat(productGroupId2products[this.productGroupIds[i]].map(p => p.productId))
      }
      this.sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs
      this.groupedProducts = this.productGroupIds.map(pgid => {
        const products = this.productGroupId2products[pgid]
        if (products && products.length > 0) {
          const firstProduct = products[0]
          // Add productGroupProductIds property if it doesn't exist
          if (!firstProduct.productGroupProductIds) {
            firstProduct.productGroupProductIds = products.map(p => p.productId)
          }
          // Add productGroupId if it doesn't exist
          if (!firstProduct.productGroupId) {
            firstProduct.productGroupId = pgid
          }
          return firstProduct
        }
        return null
      }).filter(p => p !== null)
      
      console.log('ProductCard calc: finished, groupedProducts.length =', this.groupedProducts.length)
      console.log('ProductCard calc: productGroupIds.length =', this.productGroupIds.length)
    },
    getProductGroupId2productIds: function (products) {
      const productGroupId2productIds = {}
      const productValues = Object.values(products)
      for (let i = 0; i < productValues.length; ++i) {
        const product = productValues[i]
        // Use productId as the group ID if productGroupId doesn't exist
        const groupId = product.productGroupId || product.productId
        if (productGroupId2productIds[groupId]) {
          productGroupId2productIds[groupId].push(product.productId)
        } else {
          productGroupId2productIds[groupId] = [product.productId]
        }
      }
      return productGroupId2productIds
    },
    getProductId2ProductGroupId: function (products) {
      const result = {}
      const productValues = Object.values(products)
      for (let i = 0; i < productValues.length; ++i) {
        const product = productValues[i]
        // Use productId as the group ID if productGroupId doesn't exist
        result[product.productId] = product.productGroupId || product.productId
      }
      return result
    },
    getErrorCount: function (productGroupIds, issueStatus, watchDogs, products, productId2ProductGroupId) {
      const productIds = Object.keys(products)
      const errorCountByProductGroupId = {}
      const errorCountByProductId = {}
      for (let i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = new Set()
      }
      for (let i = 0; i < productIds.length; ++i) {
        errorCountByProductId[productIds[i]] = new Set()
      }
      const watchDogKeys = Object.keys(watchDogs)
      for (let i = 0; i < watchDogKeys.length; ++i) {
        const fullKey = watchDogKeys[i]
        const watchDog = watchDogs[fullKey]
        const watchDogName = fullKey.split('_')[0]
        if (watchDog.status === 20 || watchDog.status === 21) continue
        // With flat structure, each watchDog IS an item
        const items = [watchDog]
        for (let j = 0; j < items.length; ++j) {
          const item = items[j]
          if (Array.isArray(item)) {
            for (let k = 0; k < item.length; ++k) {
              const item0 = item[k]
              if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
                if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                  errorCountByProductGroupId[item0.productGroupId].add(watchDogName)
                } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                  errorCountByProductGroupId[productId2ProductGroupId[item0.productId]].add(watchDogName)
                }
                if (item0.productId) {
                  errorCountByProductId[item0.productId].add(watchDogName)
                }
              }
            }
          } else {
            if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
              if (item.productGroupId) {
                if (errorCountByProductGroupId[item.productGroupId] && typeof errorCountByProductGroupId[item.productGroupId].add === 'function') {
                  errorCountByProductGroupId[item.productGroupId].add(watchDogName)
                }
              } else if (item.productId && productId2ProductGroupId[item.productId]) {
                if (
                  errorCountByProductGroupId[productId2ProductGroupId[item.productId]] &&
                  typeof errorCountByProductGroupId[productId2ProductGroupId[item.productId]].add === 'function'
                ) {
                  errorCountByProductGroupId[productId2ProductGroupId[item.productId]].add(watchDogName)
                }
              }
              if (item.productId) {
                if (
                  errorCountByProductId[item.productId] &&
                  typeof errorCountByProductId[item.productId].add === 'function'
                ) {
                  errorCountByProductId[item.productId].add(watchDogName)
                }
              }
            }
          }
        }
      }
      const resultByProductId = {}
      const resultByProductGroupId = {}
      for (let i = 0; i < productIds.length; ++i) {
        resultByProductId[productIds[i]] = errorCountByProductId[productIds[i]].size
      }
      for (let i = 0; i < productGroupIds.length; ++i) {
        resultByProductGroupId[productGroupIds[i]] = errorCountByProductGroupId[productGroupIds[i]].size
      }
      return {
        byProductId: resultByProductId,
        byProductGroupId: resultByProductGroupId,
      }
    },
    getWDErrorCount: function (productGroupIds, issueStatus, watchDog, products, productId2ProductGroupId) {
      const productIds = Object.keys(products)
      const errorCountByProductGroupId = {}
      const errorCountByProductId = {}
      for (let i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = 0
      }
      for (let i = 0; i < productIds.length; ++i) {
        errorCountByProductId[productIds[i]] = 0
      }

      // Safety check for watchDog and items
      if (!watchDog || !watchDog.items) {
        return {
          byProductGroupId: errorCountByProductGroupId,
          byProductId: errorCountByProductId
        }
      }

      const items = Object.values(watchDog.items)
      for (let j = 0; j < items.length; ++j) {
        const item = items[j]
        if (Array.isArray(item)) {
          for (let k = 0; k < item.length; ++k) {
            const item0 = item[k]
            if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
              if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                errorCountByProductGroupId[item0.productGroupId]++
              } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                errorCountByProductGroupId[productId2ProductGroupId[item0.productId]]++
              }
              if (item0.productId) {
                errorCountByProductId[item0.productId]++
              }
            }
          }
        } else {
          if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
            if (item.productGroupId) {
              errorCountByProductGroupId[item.productGroupId]++
            } else if (item.productId && productId2ProductGroupId[item.productId]) {
              errorCountByProductGroupId[productId2ProductGroupId[item.productId]]++
            }
            if (item.productId) {
              errorCountByProductId[item.productId]++
            }
          }
        }
      }

      return {
        byProductId: errorCountByProductId,
        byProductGroupId: errorCountByProductGroupId,
      }
    },
    addKeepingOrder: function (base0, addition0) {
      const base = base0 || []
      const addition = addition0 || []
      const result = []
      for (let i = 0; i < base.length; ++i) {
        if (addition.indexOf(base[i]) >= 0) result.push(base[i])
      }
      const addition2 = []
      for (let i = 0; i < addition.length; ++i) {
        if (base.indexOf(addition[i]) < 0) addition2.push(addition[i])
      }
      const addition3 = addition2.sort()
      for (let i = 0; i < addition3.length; ++i) {
        result.push(addition3[i])
      }
      return result
    },
    // Pagination methods
    prevPage: function () {
      console.log('ProductCard prevPage: currentPage before:', this.currentPage)
      if (this.currentPage > 0) {
        this.currentPage--
        console.log('ProductCard prevPage: currentPage after:', this.currentPage)
      }
    },
    nextPage: function () {
      console.log('ProductCard nextPage: currentPage before:', this.currentPage, 'totalPages:', this.totalPages)
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++
        console.log('ProductCard nextPage: currentPage after:', this.currentPage)
      }
    },
    goToPage: function (page) {
      console.log('ProductCard goToPage:', page, 'totalPages:', this.totalPages)
      if (page >= 0 && page < this.totalPages) {
        this.currentPage = page
        console.log('ProductCard goToPage: currentPage set to:', this.currentPage)
      }
    },
    getPageNumber: function (index) {
      if (this.totalPages <= 5) {
        return index - 1
      }

      let startPage = Math.max(0, this.currentPage - 2)
      let endPage = Math.min(this.totalPages - 1, startPage + 4)

      if (endPage - startPage < 4) {
        startPage = Math.max(0, endPage - 4)
      }

      return startPage + index - 1
    },
    formatPrice: function (price) {
      if (!price && price !== 0) return '0.00'
      return parseFloat(price).toFixed(2)
    },
    calculateMargin: function (product) {
      var margin = this.getProductMargin(product)
      return margin != null ? String(margin) : '0'
    },
    getMarginColorClass: function (margin) {
      const marginNum = parseFloat(margin)
      if (marginNum >= 30) return 'margin-high'
      if (marginNum >= 20) return 'margin-good'
      if (marginNum >= 10) return 'margin-medium'
      return 'margin-low'
    },
    getMarginCogsClass: function (margin) {
      const marginNum = parseFloat(margin)
      if (marginNum >= 30) return 'high'
      if (marginNum >= 20) return 'high'
      if (marginNum >= 10) return 'medium'
      return 'low'
    },
    getCardStripeClass: function (status) {
      if (!status) return ''
      const s = String(status).toLowerCase()
      if (s === 'owned' || s === 'own' || s === 'winning') return 'owned'
      if (s === 'lost' || s === 'losing') return 'lost'
      if (s === 'suppressed' || s === 'suppress') return 'suppressed'
      if (s === 'rotating') return 'rotating'
      return 'unknown'
    },
    getBuyBoxLabel: function (status) {
      if (!status) return '—'
      const s = String(status).toLowerCase()
      if (s === 'owned' || s === 'own' || s === 'winning') return 'Owned'
      if (s === 'lost' || s === 'losing') return 'Lost'
      if (s === 'suppressed' || s === 'suppress') return 'Suppressed'
      if (s === 'rotating') return 'Rotating'
      return status
    },
    getMarketplaceEmoji: function (marketplace) {
      const map = { US: '🇺🇸', UK: '🇬🇧', CA: '🇨🇦', DE: '🇩🇪', FR: '🇫🇷', IT: '🇮🇹', ES: '🇪🇸', MX: '🇲🇽', BR: '🇧🇷', IN: '🇮🇳', NL: '🇳🇱' }
      return map[marketplace] || '🏳️'
    },
    calculateMarginFromCogs: function (cogs, buyBoxPrice) {
      if (!cogs || !buyBoxPrice || buyBoxPrice === 0) return '0.00'
      var margin = ((buyBoxPrice - cogs) / buyBoxPrice) * 100
      return margin.toFixed(0)
    },
    getBuyBoxStatus: function (product) {
      if (!product) return null
      
      if (product.isSuppressed === true || product.suppressed === true) {
        return 'suppressed'
      }
      
      if (product.hasBuyBox === true && product.buyBoxWinner === 'you') {
        return 'owned'
      } else if (product.hasBuyBox === false) {
        return 'lost'
      }
      if (product.buyBoxRotating === true) return 'rotating'
      return null
    },
    getBuyBoxStatusClass: function (status) {
      if (!status) return ''
      const statusLower = String(status).toLowerCase()
      if (statusLower === 'owned' || statusLower === 'own' || statusLower === 'winning') return 'status-owned'
      if (statusLower === 'lost' || statusLower === 'losing') return 'status-lost'
      if (statusLower === 'suppressed' || statusLower === 'suppress') return 'status-suppressed'
      if (statusLower === 'rotating') return 'status-rotating'
      return 'status-unknown'
    },
    getBuyBoxStatusText: function (status) {
      if (!status) return 'Unknown'
      const statusLower = String(status).toLowerCase()
      if (statusLower === 'owned' || statusLower === 'own' || statusLower === 'winning') return 'OWNED'
      if (statusLower === 'lost' || statusLower === 'losing') return 'LOST'
      if (statusLower === 'suppressed' || statusLower === 'suppress') return 'SUPPRESSED'
      if (statusLower === 'rotating') return 'ROTATING'
      return status
    },
    getAlertCount: function (product) {
      const pgId = product.productGroupId || product.productId
      const r = (this.reds && this.reds[pgId]) || 0
      const a = (this.ambers && this.ambers[pgId]) || 0
      return r + a
    },
    getAsin: function (product) {
      if (product.asin) return product.asin
      if (product.productUrl) {
        const match = product.productUrl.match(/\/dp\/([A-Z0-9]+)/i)
        return match ? match[1] : '—'
      }
      return '—'
    },
    truncateToTwoLines: function (title) {
      if (!title || typeof title !== 'string') return ''
      const maxChars = 55
      if (title.length <= maxChars) return title
      const cut = title.slice(0, maxChars)
      const lastSpace = cut.lastIndexOf(' ')
      const truncated = lastSpace > 40 ? cut.slice(0, lastSpace) : cut
      return truncated.trim() + '...'
    },
    openCogsModal: function (product) {
      console.log('openCogsModal called', {
        product: product,
        productId: product ? product.productId : 'null',
        productTitle: product ? product.productTitle : 'null',
        currentCogs: product ? product.cogs : 'null'
      })
      
      if (!product) {
        console.error('openCogsModal called with null product')
        alert('Error: Product data is missing')
        return
      }
      
      if (!product.productId) {
        console.error('Product ID is missing')
        alert('Error: Product ID is missing')
        return
      }
      
      // Open the new cost & margin modal
      this.$nextTick(() => {
        if (this.$refs.productCostMarginModal) {
          this.$refs.productCostMarginModal.open(product.productId)
        } else {
          console.error('ProductCostMarginModal ref not found')
          console.error('Available refs:', Object.keys(this.$refs))
          alert('Error: Modal component not available')
        }
      })
    },
    handleCostMarginUpdated: function (productId) {
      // Emit event to parent to refresh product data
      this.$emit('cogs-updated', productId)
    },
    // Old saveCogs method removed - now handled by ProductCostMarginModal component
  },
  computed: {
    getCardsLayoutSize: function () {
      const n = this.productGroupIds.length
      const w = $(window).width()

      if (n > 4) return w > 1320 ? 'five' : 'four'
      if (n === 4) return w > 1220 ? 'four' : 'three'
      else return w > 1440 ? 'four' : 'three'
    },
    // Pagination computed properties
    totalItems: function () {
      // Server-side pagination: return count of products on current page
      if (!this.groupedProducts || !Array.isArray(this.groupedProducts)) {
        return 0
      }
      const total = this.groupedProducts.length
      console.log('ProductCard totalItems (server-side):', total)
      return total
    },
    totalPages: function () {
      // Server-side pagination: always return 1 page
      // The parent component manages actual pagination
      return 1
    },
    paginatedProducts: function () {
      // Server-side pagination: just return all products
      // The API has already filtered and paginated the data
      if (!this.groupedProducts || !Array.isArray(this.groupedProducts)) {
        console.warn('ProductCard: groupedProducts is not an array')
        return []
      }
      
      console.log('ProductCard paginatedProducts (server-side):', this.groupedProducts.length)
      return this.groupedProducts
    },
  },
  mounted: function () {
    $(this.$el).find('.circular[data-content]').popup({ delay: { show: 0, hide: 0 }, transition: 'fade' })
    $('#darkbackgr').stop().fadeOut(200) // in case animation didnt finish in WD view before switching
    
    // Verify modal ref is available
    this.$nextTick(() => {
      if (this.$refs.productCostMarginModal) {
        console.log('ProductCard mounted: ProductCostMarginModal ref is available')
      } else {
        console.warn('ProductCard mounted: ProductCostMarginModal ref not found')
      }
    })
  },
  watch: {
    worldStore: {
      handler: function (newWorldStore) {
        console.log('ProductCard watch: worldStore changed, products count:', Object.keys(newWorldStore && newWorldStore.products || {}).length)
        if (newWorldStore && newWorldStore.products && Object.keys(newWorldStore.products).length > 0) {
          console.log('ProductCard watch: calling calc with worldStore')
          this.calc(newWorldStore)
        }
      },
      deep: true
    },
  },
  created: function () {
    console.log('ProductCard created')
    console.log('ProductCard: worldStore prop exists:', !!this.worldStore)
    console.log('ProductCard: worldStore.products count:', Object.keys(this.worldStore && this.worldStore.products || {}).length)
    
    if (this.worldStore && this.worldStore.products) {
      console.log('ProductCard: calling calc with worldStore prop')
      this.calc(this.worldStore)
    } else {
      console.warn('ProductCard: worldStore prop not found or has no products')
    }
  },
}
</script>

<style scoped>
.product-card {
  overflow: hidden;
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Top stripe - colored bar only */
.card-stripe {
  height: 6px;
  min-height: 6px;
  position: relative;
  flex-shrink: 0;
}

.card-stripe.owned,
.card-stripe.status-owned { background: #10b981; }
.card-stripe.lost,
.card-stripe.status-lost { background: #f59e0b; }
.card-stripe.suppressed,
.card-stripe.status-suppressed { background: #ef4444; }
.card-stripe.rotating,
.card-stripe.status-rotating { background: #3b82f6; }
.card-stripe.unknown { background: #9ca3af; }

/* Image area - fixed height for consistent card sizing */
.card-image-area {
  position: relative;
  background: #f9fafb;
  height: 152px;
  min-height: 152px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  flex-shrink: 0;
}

.card-product-image {
  max-height: 120px;
  max-width: 100%;
  object-fit: contain;
}

.card-image-area .placeholder {
  width: 48px;
  height: 48px;
  color: #d1d5db;
}

.card-alert-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background: #ef4444;
  color: white;
}

.card-bb {
  position: absolute;
  top: 8px;
  right: 8px;
}

.bb-badge {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.bb-badge.owned,
.bb-badge.status-owned { background: #d1fae5; color: #059669; }
.bb-badge.lost,
.bb-badge.status-lost { background: #fef3c7; color: #d97706; }
.bb-badge.suppressed,
.bb-badge.status-suppressed { background: #fee2e2; color: #dc2626; }
.bb-badge.rotating,
.bb-badge.status-rotating { background: #dbeafe; color: #2563eb; }
.bb-badge.unknown,
.bb-badge.status-unknown { background: #f3f4f6; color: #6b7280; }

.card-check {
  position: absolute;
  bottom: 8px;
  left: 8px;
  width: 18px;
  height: 18px;
  border: 2px solid #9ca3af;
  border-radius: 4px;
  cursor: pointer;
  z-index: 5;
}

.card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}

.card-market {
  padding: 2px 14px;
  border-top: 1px solid #e5e7eb;
}

.market-tag {
  font-size: 12px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 3px;
  background: var(--bg-subtle);
  color: var(--text-secondary);
}

.card-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 14px;
  height: calc(2.8em + 8px);
  max-height: calc(2.8em + 8px);
  min-width: 0;
  width: 100%;
  flex-shrink: 0;
}

.card-asin {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
  padding: 0px 14px;
}

.card-rating {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  padding: 0px 14px;
}

.card-rating-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-left: 6px;
  border-radius: 50%;
  background: #ef4444;
  vertical-align: middle;
}

/* COGS strip */
.card-cogs-strip {
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  align-items: stretch;
  margin-top: 12px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.card-cogs-strip.missing {
  background: var(--accent-orange-light);
  border-top-color: #FDE8CC;
}

.cogs-col {
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 9px 14px;
}

.cogs-col-add {
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.cogs-strip-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 2px;
}

.cogs-strip-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.cogs-strip-value.high,
.cogs-strip-value.margin-high,
.cogs-strip-value.margin-good { color: #10b981; }
.cogs-strip-value.medium,
.cogs-strip-value.margin-medium { color: #f59e0b; }
.cogs-strip-value.low,
.cogs-strip-value.margin-low { color: #ef4444; }

.cogs-strip-value.empty {
  color: var(--text-tertiary);
  font-weight: 400;
  font-style: italic;
}

.cogs-strip-divider {
  width: 1px;
  min-width: 1px;
  background: var(--border-light);
  align-self: stretch;
}

.add-cogs {
  font-size: 12px;
  font-weight: 600;
  color: var(--accent-orange);
  cursor: pointer;
}

.add-cogs:hover {
  color: var(--accent-orange-hover);
  text-decoration: underline;
}

.cogs-col-clickable {
  cursor: pointer;
}

.cogs-col-clickable:hover .cogs-strip-value {
  text-decoration: underline;
  text-decoration-color: rgba(249, 115, 22, 0.5);
}

.cogs-col-with-edit {
  flex-direction: column;
  align-items: stretch;
}

.edit-cogs-link {
  margin-top: 6px;
  font-size: 11px;
  font-weight: 600;
  align-self: flex-start;
}

/* Footer */
.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.card-footer-sales {
  font-size: 13px;
  color: #374151;
}

.action-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: var(--text-tertiary);
  cursor: pointer;
  transition: all 0.15s;
  border: 1px solid var(--border-light);
  background: var(--bg-white);
}

.action-btn:hover {
  color: #374151;
}

.action-btn svg {
  width: 18px;
  height: 18px;
}
</style>

<style>
.product-card-wrapper .ui.cards {
  align-items: stretch;
}
.product-card-wrapper .ui.cards > .card {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-self: stretch;
  min-height: 0;
}
.product-card-wrapper .card-name {
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.flip-list-move {
  transition: transform 1s;
}
#prodCont .ui.segment:first-child {margin-top:12px;}
#prodCont .ui.segment:last-child {margin-bottom:12px;}
/* #prodCont .ui.segment.stacked .extra.content:last-child {padding-bottom:0px;} */

#prodCont .extra.content .chartbutton {opacity:.6; padding: 7px 11px;}
#prodCont .extra.content .chartbutton:hover {opacity:1 !important;}

#prodCont .product-card:hover,
#prodCont .card:hover {z-index: initial; -webkit-transform: translateY(-2px); transform: translateY(-2px); transition: all 0s;}
</style>



// WEBPACK FOOTER //
// ProductCard.vue?2deffe72